import classNames from "classnames";
import { MouseEventHandler } from "react";
import { Link, To } from "react-router-dom";
import ChevronLeftIcon from "../../../icons/ChevronLeftIcon";

type PropTypes = {
  to?: To;
  replace?: boolean;
  onClick?: MouseEventHandler;
  variant?: "white" | "grey";
  className?: string;
  "data-test-id"?: string;
};

const BackButton = ({ onClick, to, replace, className, variant = "white", "data-test-id": dataTestId }: PropTypes) => {
  const Inner = (
    <button
      className={classNames(
        `
        outline-none transition
        flex items-center justify-center w-[50px] h-[50px] rounded-full
        cursor-pointer bg-grey-lightest hover:bg-grey-light
        `,
        {
          "bg-grey-lightest hover:bg-grey-light": variant === "white",
          "bg-pinball hover:bg-grey-lightest": variant === "grey",
        },
        className,
      )}
      onClick={onClick}
      data-test-id={dataTestId}
    >
      <ChevronLeftIcon className="w-6 h-6" />
    </button>
  );

  if (to) {
    return (
      <Link to={to} replace={replace} onClick={onClick} data-test-id={dataTestId}>
        {Inner}
      </Link>
    );
  }

  return <>{Inner}</>;
};

export default BackButton;
